// D3.1: the logo hover state, from Figma node 11483:7485 ('logo-hover'). That frame is 389px
// wide and holds both states side by side — read off the export, the left logo is 6 black
// paths + 2 × #4CBC18 and the right is the same 8 paths as 6 × #4F6544 + 2 × #6AD836, which
// matches reilm-logo.svg path for path. So the mark brightens and the wordmark dims.
//
// This has to be inline SVG: an <img> is an opaque document, and no amount of CSS on the tag
// reaches the fills inside it. Hover is driven by a `group` ancestor rather than by :hover on
// the svg, because the state belongs to the whole link — hovering the gap between two letters
// should not drop it.
const MARK = 'fill-[#4CBC18] transition-colors duration-200 group-hover:fill-[#6AD836]'
const WORD = 'fill-[#000000] transition-colors duration-200 group-hover:fill-[#4F6544]'

// The original export wrapped these in a clipPath the exact size of the viewBox, so it clipped
// nothing; dropped, because a fixed id would collide the moment two logos share a page.
const ReilmLogo = ({ className = 'w-[148px] h-[43px]' }) => (
  <svg
    className={className}
    viewBox="0 0 148 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="REILM"
  >
    <path
      className={WORD}
      d="M22.1365 11.4577L25.5936 0L13.9496 2.83051L15.8138 4.79541L0 19.8366L0.0086572 43H6.3313V22.5402L20.1684 9.38017L22.1365 11.4577Z"
    />
    <path className={MARK} d="M23.4437 16.7305H17.375V22.7983H23.4437V16.7305Z" />
    <path
      className={MARK}
      d="M16.2248 43.0007L34.3992 23.9028V36.7742L26.1431 36.78L19.7743 43.0007H40.7247V21.4964L34.2665 15.0391L7.71484 43.0007H16.2248Z"
    />
    <path
      className={WORD}
      d="M126.449 43.0016V21.2656H126.477L138.085 37.7237L136.325 37.3264L147.904 21.2656H147.96V43.0016H143.846V30.5446L144.101 32.6728L137.035 42.7179H136.978L129.712 32.6728L130.422 30.7148V43.0016H126.449Z"
    />
    <path className={WORD} d="M105.43 22.1172H109.545V39.0293H119.364V43.0019H105.43V22.1172Z" />
    <path className={WORD} d="M93.0859 22.1172H97.2005V43.0019H93.0859V22.1172Z" />
    <path
      className={WORD}
      d="M71.3477 22.1172H85.5942V26.0898H75.4629V30.5449H84.4302V34.5175H75.4629V39.0293H85.9913V43.0019H71.3477V22.1172Z"
    />
    <path
      className={WORD}
      d="M55.3832 22.1172C57.1427 22.1172 58.6279 22.4104 59.8387 22.9968C61.0495 23.5644 61.9671 24.3778 62.5915 25.4372C63.2347 26.4776 63.5563 27.7167 63.5563 29.1544C63.5563 30.0057 63.4239 30.857 63.159 31.7083C62.9131 32.5595 62.4969 33.3352 61.9104 34.0351C61.3428 34.735 60.586 35.3026 59.64 35.7377C58.6941 36.1538 57.5211 36.3619 56.1211 36.3619H53.1696V43.0019H49.0547V22.1172H55.3832ZM56.0927 32.3893C56.9251 32.3893 57.5684 32.219 58.0224 31.8785C58.4954 31.5191 58.8265 31.1029 59.0157 30.63C59.2049 30.1381 59.2995 29.6936 59.2995 29.2963C59.2995 29.0693 59.2617 28.7855 59.186 28.445C59.1292 28.0856 58.9968 27.7262 58.7887 27.3667C58.5806 27.0073 58.2589 26.7046 57.8238 26.4587C57.4076 26.2128 56.84 26.0898 56.1211 26.0898H53.1696V32.3893H56.0927ZM59.9522 34.9431L65.1172 43.0019H60.3211L55.0426 35.0566L59.9522 34.9431Z"
    />
  </svg>
)

export default ReilmLogo
